import request from '@/utils/request'
import qs from 'qs'
import { rsa } from '@/utils/utils'
import { LocaleMgr } from 'i18n'

const API_GATEWAY = process.env.VUE_APP_API_GATEWAY_URL
const APP = `${API_GATEWAY}/app` // 9097 端口
const MQTT = `${API_GATEWAY}/mqtt` // 9093 端口
const DEPRECATED_BASE_URL_MANAGEMENT = `${API_GATEWAY}/managent`

const DEPRECATED_USER = `${API_GATEWAY}/user` // 9094 端口
// const WORK = `${API_GATEWAY}/work` // 9099 端口
// const MANAGEMENT = `${API_GATEWAY}/managent` // 9096 端口
// const BASE_URL_APP = `${API_GATEWAY}/summary` // 9095 端口
// const HOST = `${API_GATEWAY}/host`

const USER = APP
const WORK = APP
const MANAGEMENT = APP
const BASE_URL_APP = APP
const HOST = APP
// 获取验证码
export function getVerifyCode(data) {
  return request(USER + `/nb_sms/send/verify`, {
    method: 'PUT',
    params: {
      ...data,
    },
  })
}

// 钉钉内 绑定公司
export function bindCompany(data) {
  return request(WORK + `/micro/bind/company`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 绑定钉钉
// export function noticeDing(data) {
//   return request(WORK + `/micro/ding/notice`, {
//     method: 'POST',
//     data: {
//       ...data,
//     },
//   })
// }

// H5注册
export function register(data) {
  return request(WORK + `/micro/register/h5`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// H5校验用户注册
export function verifyRegister(data) {
  return request(WORK + `/micro/register/verify`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// H5人员密码登录
export function pwdLogin(data) {
  return request(WORK + `/micro/login`, {
    method: 'POST',
    data: {
      ...data,
      password: data.password && rsa(data.password),
    },
  })
}

// H5人员验证码登录
export function codeLogin(data) {
  return request(WORK + `/micro/login/h5`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 后台根据token获取用户信息
export function queryStaffToekn(data) {
  return request(WORK + `/new_work/staff/token`, {
    method: 'GET',
    headers: {
      Authorization: data?.token,
    },
    params: {
      ...data,
    },
  })
}

// 用户刷新电子钥匙
export function refreshElectronicKey(data) {
  return request(MANAGEMENT + `/new_work/staff/token/refreshElectronicKey`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// H5设置密码
export function setPassword(data) {
  return request(WORK + `/micro/setPwd/h5`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 修改newWork后台人员密码
export function setInitialPwd(data) {
  return request(WORK + `/new_work/staff/update/password`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 忘记密码更新密码
export function updatePwd(data) {
  return request(WORK + `/micro/updatePwd/h5`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 根据旧密码设置新密码
export function changePwd(data) {
  return request(WORK + `/micro/changePwd`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 绑定微信
export function bindWechat(data) {
  return request(WORK + `/micro/weChat/bind`, {
    method: 'POST',
    data,
  })
}

// 绑定微微信获取token信
export function getWXToken(data) {
  return request(WORK + `/micro/wxLogin`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 取消会议记录
export function cancelAppointment(data) {
  return request(MANAGEMENT + `/new_work/appointment/cancel/{id}`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 我创建的会议
export function queryCreatedAppointmentCount(data) {
  return request(WORK + `/new_work/appointment/count/created`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 结束会议记录
export function finishAppointment(data) {
  return request(WORK + `/new_work/appointment/finish/{id}`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 根据ID查询预约记录及签约模版
export function getAppointmentByID(data) {
  return request(WORK + `/new_work/appointment/get`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 我的预约
export function queryMyAppointment(data) {
  return request(WORK + `/new_work/appointment/query/appointment`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 更新与会人员、外部人员
export function updateAppointmentPeople(data) {
  return request(WORK + `/new_work/appointment/update/appointment/people`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 根据日期查询某天会议室预约记录
export function queryAppointmentList(data) {
  return request(MANAGEMENT + `/new_work/appointment/list/date`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 会议室配置获取
export function getMeetingRoomConfig(data) {
  return request(MANAGEMENT + `/meetingRoomConfig/get`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 会议室列表-区域筛选使用
// export function getMeetingRoomByArea(data) {
//   return request(MANAGEMENT + `/meetingRoom/list`, {
//     method: 'GET',
//     params: {
//       ...data,
//     },
//   })
// }

// 会议签到
export function meetingSignIn(data) {
  return request(MANAGEMENT + `/meetingStaffSign`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 会议签到：查询会议签到记录
export function queryMeetingSignIn(data) {
  return request(MANAGEMENT + `/meetingStaffSign`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 会议签到：一体机校验会议室开始会议动作
export function startMeeting(data) {
  return request(
    MANAGEMENT +
      `/meetingDevice/padVerifyAppointmentStart?appointmentId=${data.appointmentId}&mobile=${data.mobile}`,
    {
      method: 'GET',
      params: {
        ...data,
      },
    }
  )
}

// 办公区域列表
export function getWorkspace(data) {
  return request(MANAGEMENT + `/workspace/list`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
// 办公区域列表
// export function getWorkspace(data) {
//   return request(MANAGEMENT + `/meetingRoom/page/search`, {
//     method: 'GET',
//     params: {
//       ...data,
//     },
//   })
// }

// 会议室设备列表
export function getMeetingDevice(data) {
  return request(WORK + `/meetingDevice/list`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 获取企业后台用户列表
export function getUserList(data) {
  return request(MANAGEMENT + `/new_work/staff/user/list`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//==============我的预约=============
export function queryMyAppointmentList(data) {
  return request(MANAGEMENT + '/new_work/appointment/query/appointment', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
//邀请我的
export function queryInviteMyAppointmentList(data) {
  return request(MANAGEMENT + '/new_work/appointment/appointment/invitation/appointment', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
//会议是否接受
export function refuseMeeting(data) {
  return request(MANAGEMENT + `/meetingNotice/check`, {
    method: 'POST',
    params: {
      ...data,
    },
  })
}
//取消会议记录
export function cancelMeeting(id) {
  return request(MANAGEMENT + `/new_work/appointment/cancel/${id}`, {
    method: 'POST',
    data: id,
  })
}

//会议室今日预约记录删除
export function deleteAppointment(id) {
  return request(MANAGEMENT + `/new_work/appointment/finish/${id}`, {
    method: 'POST',
    data: id,
  })
}

//取消线上会议记录
export function cancelOnlineMeeting(id) {
  return request(MANAGEMENT + `/new_work/appointment/cancelOnline/${id}`, {
    method: 'POST',
    data: id,
  })
}

// 即时预约-PC
export function bookAppointment(data) {
  return request(
    MANAGEMENT +
      `/new_work/appointment/web/multi/appointment?developerId=${data.developerId}&companyId=${data.companyId}`,
    {
      method: 'POST',
      data: {
        ...data,
      },
    }
  )
}
//更新即时预约-PC
export function webAppointmentUpdate(data) {
  return request(MANAGEMENT + `/new_work/appointment/web/appointment/update`, {
    method: 'POST',
    data,
  })
}
//更新即时线上会议预约-PC
export function appointmentOnlineUpdate(data) {
  return request(MANAGEMENT + `/new_work/appointment/web/appointmentOnline/update`, {
    method: 'POST',
    data,
  })
}
//获取所有签到模板列表
export function getTemplateList(data) {
  return request(WORK + '/new_work/sign/list/template', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//根据ID查询预约记录及签约模版
export function getAppointment(data) {
  return request(WORK + '/new_work/appointment/get', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//通知参会人
export function informAppointment(data) {
  return request(MANAGEMENT + '/new_work/appointment/informUpdate', {
    method: 'PUT',
    data: {
      ...data,
    },
  })
}
//更新签到模版
export function updateSignTemplate(data) {
  return request(MANAGEMENT + `/new_work/appointment/update/sign`, {
    method: 'PUT',
    data: {
      ...data,
    },
  })
}

//单独通知参会人
export function notifyAppointment(data) {
  return request(MANAGEMENT + '/new_work/appointment/notify/participants', {
    method: 'PUT',
    data,
  })
}

//通过免登CODE获取钉钉userId
export function noticeDing(data) {
  return request(WORK + '/ding_talk/auth/user_id', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//查询是否是节假日
//info为空时 0工作日 1假日（含周未及调休的节日）2节日
//info为2时 1 工作日 2调休 3周未 4假日
export function getHoliday(data, info) {
  return request(DEPRECATED_USER + `/holiday/get/${data}`, {
    method: 'GET',
    params: { info: info },
  })
}

//会议审批同意或拒绝
export function checkUsing(data) {
  return request(MANAGEMENT + `/meetingNotice/check`, {
    method: 'POST',
    params: {
      ...data,
    },
  })
}

//邀约信息审核
export function auditVisit(data) {
  return request(MANAGEMENT + `/visit/audit`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//邀约信息查看 - 不加密
export function getVisit(data) {
  return request(MANAGEMENT + `/visit/get`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//邀约信息查看 - 加密
export function getVisitFree(data) {
  return request(APP + `/visit/publicGet`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//邀约信息列表
export function queryVisit(data) {
  return request(MANAGEMENT + `/visit/query`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//外部人员邀约信息保存
export function visitorSave(data) {
  return request(APP + `/visit/saveExter`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//邀约信息更新
export function visitorUpdate(data) {
  return request(MANAGEMENT + `/visit/update`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//邀约签到
export function signInVisit(data) {
  return request(MANAGEMENT + `/visit/signIn`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//邀约信息取消
export function updateCancel(data) {
  return request(MANAGEMENT + `/visit/cancel`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//访客提前结束
export function visitEndEarly(id) {
  return request(APP + `/visit/${id}/finish`, {
    method: 'POST',
  })
}

//邀约操作设备
export function operateDevice(data, token) {
  return request(MANAGEMENT + `/visit/device/operate`, {
    method: 'POST',
    data: {
      ...data,
    },
    headers: { Authorization: token },
  })
}

//预约码校验
export function getVisitCode(data) {
  return request(MANAGEMENT + `/visit/verifyInvitationCode`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

/**
 * 获取腾讯云实时音视频用户签名
 */
export const getUseSign = (sdkAppId, userId) => {
  return request({
    method: 'GET',
    url: BASE_URL_APP + `/robot_account?sdkAppId=${sdkAppId}&userId=${userId}`,
  })
}

//根据关键词获取字典列表
export function getDictionary(itemKey) {
  return request(USER + `/nb_dictionary/get/${itemKey}`, {
    method: 'GET',
  })
}

//图片上传
export function upload(data) {
  return request(DEPRECATED_BASE_URL_MANAGEMENT + '/plat/files/uploadRemote', {
    method: 'POST',
    data,
  })
}

//人脸上传
export function uploadFace(data) {
  return request(DEPRECATED_BASE_URL_MANAGEMENT + '/plat/files/uploadRemote?type=face', {
    method: 'POST',
    data,
  })
}

//大图片上传
export function uploadBigFiles(data) {
  return request(DEPRECATED_BASE_URL_MANAGEMENT + '/plat/files/upload/stream', {
    method: 'POST',
    data,
  })
}

// 序列号获取配置
export function getSerialConfig(data) {
  return request(MANAGEMENT + `/robot/come-in/config`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 主机号号获取配置
export function getHostConfig(hostId) {
  return request(HOST + `/host_config/get/${hostId}`, {
    method: 'GET',
  })
}

//根据员工ID获取对应多角色去重权限
export function getRole(data) {
  return request(WORK + `/new_work/staff/staff/role/permission`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 机器人断开连接信息保存
export function breakRobotConnect(data) {
  return request(WORK + `/robotConnect/break`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 机器人连接信息保存
export function saveRobotConnect(data) {
  return request(WORK + `/robotConnect/save`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 心跳
export function pingRobotConnect(data) {
  return request(WORK + `/robotConnect/ping`, {
    method: 'PUT',
    data: {
      ...data,
    },
  })
}

//根据ID查询用户
export function getStaffById(id) {
  return request(MANAGEMENT + `/new_work/staff/get/${id}`, {
    method: 'GET',
  })
}

// 根据shareid获取邀约信息
export function getVisitByShareId(data) {
  return request(WORK + `/visit/getByShareId`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 企业编码查询企业信息
export async function getCompanyInfo(companyCode) {
  const res = await request(WORK + `/new_work/company/query/code/${companyCode}`, {
    method: 'GET',
  })
  {
    const enterpriseLanguage = res?.enterpriseLanguage
    enterpriseLanguage && localStorage.setItem('enterpriseLanguage', enterpriseLanguage)
    await LocaleMgr.singleton.init({ company: res.id })
  }
  return res
}

//获取机器人点位配置
export function getRobotWork(companyId) {
  return request(MANAGEMENT + `/work_robot/get/${companyId}`, {
    method: 'GET',
  })
}

//根据机器人序列号获取机器人点位
export function getRobotPoint(serial) {
  return request(BASE_URL_APP + `/room_position/getRobotPoint/serial/${serial}`, {
    method: 'GET',
  })
}

//议室设备管理列表-分页使用
export function queryAIOList(data) {
  return request(WORK + '/meetingDeviceManage/query', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//获取微信分享签名
export function getJsApiTicket(data) {
  return request(WORK + '/visit/getJsApiTicket', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//按部门树形获取人员信息
export function getstaffByDepartment(data) {
  return request(WORK + '/new_work/staff/department/staff', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//获取房间ID
export const joinRoom = serial => {
  return request({
    method: 'POST',
    url: BASE_URL_APP + `/video/add/${serial}&source=work-H5`,
  })
}
// 用户上传人脸照片
export function saveStaffFace(staffId, data) {
  return request(WORK + `/new_work/staff/${staffId}/face`, {
    method: 'PUT',
    params: {
      ...data,
    },
  })
}
//获取会议室是否占用中
export function getHoldUpTime(data) {
  return request(WORK + `/new_work/appointment/getHoldUpTime`, {
    method: 'POST',
    data: data,
  })
}
// H5人员钉微自动登录
export function autoLogin(data) {
  return request(WORK + `/micro/autoLogin`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}
// 泛微自动登录
export const fwAutoLogin = data => {
  return request(APP + '/fw/h5/checkToken', {
    method: 'GET',
    params: data,
  })
}
// 竹云自动登录
export const autoZuYunLogin = data => {
  return request(WORK + '/zy/oauth2/getUserInfo', {
    method: 'GET',
    params: {
      source: 'h5',
      ...data,
    },
  })
}
//议室设备管理列表-分页使用
export function meetingRoomMostUsed(data) {
  return request(MANAGEMENT + '/meetingRoom/most/used', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
//包含会议室的区域
export function getIncludeWorkspace(data) {
  return request(MANAGEMENT + '/workspace/include/room', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//内网控制设备
export function IntranetControlDevice(ip, deviceId, data) {
  console.log(data, 'data')
  return request(`http://${ip}/v0.1/device/${deviceId}/execution`, {
    method: 'POST',
    body: { ...data },
  })
}

//根据设备id获取门禁管理信息--废弃掉了
// export const getAccessControl = serial => {
//   return request(WORK + `/access-control/device-serial/detail?deviceSerial=${serial}`)
// }

// 获取门禁开门信息-**适配门禁组新加**
export const getAccessControlNew = (serial, companyId) => {
  console.log(serial, 'data', companyId)
  return request(
    WORK + `/access-control/bind-device?deviceSerial=${serial}&companyId=${companyId}`,
    {
      method: 'GET',
      cacheEnable: true,
    }
  )
}

//设备控制
export const execDevice = data => {
  console.log('发送控制命令:', data)
  data['deviceConfig'] = JSON.stringify(data['deviceConfig'])
  data = qs.stringify(data)
  return request(WORK + `/nw_host/controlDevice?${data}`, {
    dataType: 'text',
  })
}

// 根据公司corpid获取用户个人信息
export function getInfoByCorpid(data) {
  return request(WORK + `/ding_talk/getUserInfoByCorpid`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 手机验证码登录钉钉newWork后台人员
export function codeLoginByDing(data) {
  return request(WORK + `/micro/loginDingH5`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}
// 账号密码登录钉钉newWork后台人员
export function pwdLoginByDing(data) {
  return request(WORK + `/micro/loginDingPwd`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}
// 即时线上预约-PC-多会议室
export function appointmentOnline(data) {
  return request(MANAGEMENT + `/new_work/appointment/web/multi/appointmentOnline`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 邀约地址查询
export function getVisitaddress(companyId) {
  return request(WORK + `/visitaddress/getByCid/?companyId=${companyId}`, {
    method: 'GET',
  })
}
// 根据时间判断是否重叠并计算重叠后两个时间段的时间差
export function dateOverlap(data) {
  return request(APP + `/new_work/appointment/h5/dateOverlap`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 根据会议id查询会议留言
export function getMeetingMessage(data) {
  return request(APP + `/new_work/appointment/get/meetingLeaveMessage`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
// 保存会议留言
export function saveMeetingMessage(data) {
  return request(APP + `/new_work/appointment/add/meetingLeaveMessage`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//会议室会议预约屏配置查看
export function queryMeetingDevice(developerId) {
  return request(MANAGEMENT + '/meetingDevice/queryPad', {
    method: 'GET',
    params: {
      developerId,
    },
  })
}

//今日会议室会议状态数量
export function meetingNumber(data) {
  return request(MANAGEMENT + `/meetingRoomOverview/meetingNumber`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
//关联会议
export function queryMyRelation(data) {
  return request(MANAGEMENT + '/new_work/appointment/query/relation', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//查询会议纪要
export function queryMeetingSummary(data) {
  return request(MANAGEMENT + '/meetingSummary', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//添加会议纪要
export function addMeetingSummary(data) {
  return request(MANAGEMENT + `/meetingSummary`, {
    method: 'POST',
    data,
  })
}

// 删除会议纪要
export function deleteMeetingSummary(id) {
  return request(MANAGEMENT + `/meetingSummary/${id}`, {
    method: 'DELETE',
  })
}

//查询会议纪要上传人数
export function queryPeopleCount(data) {
  return request(MANAGEMENT + '/meetingSummary/peopleCount', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//获取主机在线情况
export function queryOffline(developerId) {
  return request(WORK + `/bigdata-statistic/Offline?developerId=${developerId}`, {
    method: 'GET',
  })
}

//所有会议信息
export function queryAllMettingList(data) {
  return request(WORK + '/bigdata-statistic/getMeetingVisitSummary', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
export function queryAppointment(data) {
  return request(WORK + '/station-record/getStationReserveRecords', {
    method: 'POST',
    data: {
      ...data,
    },
  })
}
export function updateAppointmentStatus(data) {
  return request(WORK + '/station-record/stationReserveRecordDispose', {
    method: 'POST',
    params: {
      ...data,
    },
  })
}

//企业微信自动登录
export function ovWxAutoLogin(data) {
  return request(WORK + '/micro/autoLogin', {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// =========工位预约列表=========
// 查询工位预约的信息列表
export function queryAppointmentStaion(data) {
  return request(WORK + `/make-station/getStationReserveStatus`, {
    method: 'POST',
    data,
  })
}
// 根据一级空间id查询 预约的配置项
export function queryAppointmentSeetingConfig(id) {
  return request(WORK + `/make-setting/getWorkSpaceId?id=${id}`)
}
/**
 * 查询到当前工区下的工位配置信息图
 * @param areaId 二级工区id
 * @returns
 */
export function queryAppointmentStaionSettingList(areaId) {
  return request(WORK + `/work-area-setting/getByTwoWorkSpaceId?id=${areaId}`)
}
// 根据工位进行工位预约
export function updateAppointmentStaion(data, isconfirm) {
  return request(WORK + `/make-station/makeStation?${isconfirm ? 'isConfirm=true' : ''}`, {
    method: 'POST',
    data,
  })
}
// 按部门树形获取人员信息
export const staffDepartmentStaff = data => {
  return request(MANAGEMENT + `/new_work/staff/department/staff?companyId=${data.companyId}`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 查询不可用时间段 type DAY 按天 HALF_A_DAY 半天 HOURS 小时 HALF_A_HOUR 半小时 预约的配置项
export function queryDisableDate(data) {
  return request(WORK + `/station-record/getStationRecordDate`, {
    params: data,
  })
}

// 根据空间、工区、日期、工位查询该工位下选中日期范围内的所有预约信息
export function queryAppointmentHistory(data) {
  return request(WORK + `/make-station/getFilterByMakeStationInfo`, {
    method: 'POST',
    data,
  })
}

// 根据一级空间id查询 预约的配置项
export function queryAppointmentSpaceOrWorkAreaList(developerId) {
  return request(
    WORK + `/work-area-setting/getByDeveloperAndWorkspaceId?developerId=${developerId}`
  )
}

// 获取工位最小值可预约天数
export function queryShowDayMin(data) {
  return request(WORK + `/make-setting/getMakeSettingForShowDayMinimum`, {
    params: {
      ...data,
    },
  })
}
export function reservationInfo(id, type) {
  return request(WORK + `/make-station/getStationHeadByIdInfo`, {
    method: 'GET',
    params: {
      make_recode_id: id,
      type,
    },
  })
}
export function reservationInfoCode(code, type) {
  return request(WORK + `/make-station/getStationHeadByCodeInfo`, {
    method: 'GET',
    params: {
      make_recode_code: code,
      type,
    },
  })
}

/**
 * 查询工位占用状态，判断该工位：有人/无人。（本次通过华为人体传感器实现的）
 * @param data stationIds:工位id集合
 * @returns
 */
export function getStationHoldUpTime(stationIds) {
  return request(WORK + '/new_work/appointment/getStationHoldUpTime', {
    method: 'POST',
    data: stationIds,
  })
}

// 反机器人验证-获取验证图片  以及token
export function reqGet(data) {
  return request(WORK + '/new_work/staff/getVerificationCode', {
    method: 'POST',
    data,
  })
}

// 反机器人验证-滑动或者点选验证
export function reqCheck(data) {
  return request(WORK + '/new_work/staff/verificationCodeCheck', {
    method: 'POST',
    data,
  })
}
// 提前结束工位预约
export const earlyTermination = data => {
  return request(WORK + `/station-record/stationEarlyTermination`, {
    method: 'POST',
    params: {
      ...data,
    },
  })
}

//冲突的预约信息查询
export function queryConfitAppointments(bodyDate, queryDate) {
  return request(WORK + `/make-station/queryStationMakeInfo?${qs.stringify(queryDate)}`, {
    method: 'POST',
    data: bodyDate,
  })
}
//分页查询banner
export function queryBanners(data) {
  return request(MANAGEMENT + `/banners`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//根据ID查询banner详情
export function queryBannersById(id) {
  return request(MANAGEMENT + `/banners/${id}`, {
    method: 'GET',
  })
}

// 用户密码修改提醒-查询最后更新时间
export function getUserLasterUpdateTime(staffId) {
  return request(WORK + `/new_work/staff/${staffId}/updatePwdTime`)
}

// 用户密码修改提醒-查询最后更新时间
export function updateUserLasterUpdateTime(staffId) {
  return request(WORK + `/new_work/staff/${staffId}/updatePwdTime`, {
    method: 'PUT',
  })
}

// params {userId: string, language:string}
// 更新用户语言
export function updateUserLanguage(params) {
  return request(WORK + `/new_work/staff/updateUserLanguage`, {
    method: 'PUT',
    params,
  })
}

// 访客接受邀约更新状态
export function visitStatus(data) {
  return request(MANAGEMENT + `/visit/updateVisitAcceptedStatus?id=${data.id}`, {
    method: 'POST',
    data,
  })
}

//将code传给后端
export function sendCode(code) {
  console.log('将code传给后端', code)
  return request(WORK + `/visit/getWechatOpenId?`, {
    method: 'GET',
    params: {
      code,
    },
  })
}

//获取展会邀约信息接口
export function getExhibition(wechatOpenId) {
  console.log('接口的wechatOpenId', wechatOpenId)
  return request(WORK + `/visit/getExhibitionAddVisitInfo?wechatOpenId=${wechatOpenId}`, {
    method: 'GET',
  })
}

//存储展会邀约信息接口
export function postExhibition(data) {
  console.log('存储展会邀约信息接口的data', data)
  return request(WORK + `/visit/addExhibitionVisitInfo`, {
    method: 'POST',
    data,
  })
}

// 发送 mqtt 到设备
export function sendRobotMqtt(data) {
  return request(MQTT + `/mqtt/sendRobot`, {
    method: 'POST',
    data,
  })
}

//修改用户信息
export function postUserInfo(data) {
  return request(MANAGEMENT + `/new_work/staff/update`, {
    method: 'POST',
    data,
  })
}

// 心理舒缓接口--无需验证/codecompanyCode

//根据企业code获取配置
export function getConfig(data) {
  return request(
    WORK +
      `/visit/getVisitExhibitionConfig?companyCode=${data.companyCode}&configCode=${data.configCode}`,
    {
      method: 'GET',
    }
  )
}

// 会议室列表
export function getMeetingRoomByPublic(data) {
  return request(WORK + `/external/meetingRoom/meetingRoomList`, {
    method: 'POST',
    data,
  })
}
// 根据日期查询某天会议室预约记录
export function publicAppointmentList(data) {
  return request(WORK + `/external/meetingRoom/list/date`, {
    method: 'POST',
    data,
  })
}

// 即时预约-PC
export function publicbookAppointment(data) {
  return request(WORK + `/external/multi/appointment?`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//外部人员邀约信息保存
export function PublicvisitorSave(data) {
  return request(WORK + `/external/visit/saveExter`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 创建自定义日程
export function createCalendar(data) {
  return request(WORK + `/calendar`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 修改自定义日程
export function updateCalendar(data) {
  return request(WORK + `/calendar`, {
    method: 'PUT',
    data: {
      ...data,
    },
  })
}

// 查询自定义日程列表-不包括工位
export function queryCalendar(data) {
  return request(WORK + `/calendar/todo`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 查询自定义日程列表-单工位数据
export function queryCalendarStation(data) {
  return request(WORK + `/bigdata-statistic/getStationRecordSummary`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 查询单个自定义日程详情
export function queryCalendarById(data) {
  return request(WORK + `/calendar/${data.id}`, {
    method: 'GET',
  })
}
// 查询单个自定义日程详情加密code
export function queryCalendarByIdCode(data) {
  return request(WORK + `/calendar/code`, {
    method: 'GET',
    params: {
      code: data.code,
    },
  })
}

// 取消单个自定义日程
export function cancelCalendarById(data) {
  return request(WORK + `/calendar/${data.id}/cancel?staffId=${data.staffId}`, {
    method: 'POST',
  })
}

// 查询多个自定义日程的列表
export function queryRepeatCalendar(data, staffIds) {
  return request(WORK + `/calendar?staffIds=${staffIds}`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//添加按钮：返回企业开通的对接权限
export const addButtonApi = companyId => {
  return request(MANAGEMENT + '/new_work/company/queryPermissions', {
    method: 'GET',
    params: {
      companyId,
    },
  })
}
// 审批信息列表
export function queryVisitAuditData(data) {
  return request(MANAGEMENT + `/visit/query/audit`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 获取房间类型空间的父空间 平铺接口
export function querySuperiorWorkspace(data) {
  return request(WORK + `/workspaceNew/querySuperiorWorkspace`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
// 获取全部空间-绑定工区的空间
export function queryStationParent(data) {
  return request(WORK + `/workspaceNew/queryStationParent`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
// 获取绑定设备的房间列表-架构层级调整
export function getWorkAreaList(data) {
  return request(WORK + `/work-area-setting/getAreaList`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
// 访客审批
export function visitAudit(data) {
  return request(MANAGEMENT + `/visit/audit`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//查询移动端人脸上传开关权限
export const getUploadFaceLimits = data => {
  return request(MANAGEMENT + '/new_work/staff/config/uploadFace', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}
export const getUploadKeyLimits = data => {
  return request(MANAGEMENT + '/new_work/staff/config/electronicKey', {
    method: 'GET',
    params: data,
  })
}

// 会议室列表-区域筛选使用
export function getMeetingRoomByArea(data) {
  return request(MANAGEMENT + `/workspaceNew/roomList`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

export const LanguagesRESTful = {
  baseUrl: MANAGEMENT + '/languages',
  list(params) {
    return request(this.baseUrl + '/all', { params })
  },
  post(data) {
    return request.post(this.baseUrl, { data })
  },
  put(data) {
    return request.put(this.baseUrl, { data })
  },
  delete(id) {
    return request.delete(`${this.baseUrl}/${id}`)
  },
  publish(id) {
    return request.get(`${this.baseUrl}/publish/${id}`)
  },
}

//检查当前申请人是否需要审批
export function whetherNeedApproval(data) {
  return request(MANAGEMENT + '/process-config/whetherNeedApproval', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

//会议室查询
export function getMeetingRoomById(id) {
  return request(MANAGEMENT + `/meetingRoom/${id}`, {
    method: 'GET',
  })
}

//根据用户Id获取部门数据
export function getStaffDepartment(data) {
  return request(MANAGEMENT + '/process-config/getStaffDepartment', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// H5待办列表接口
export function h5MeetingServiceRecord(data) {
  return request(MANAGEMENT + `/flow/h5MeetingServiceRecord`, {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 新建审批
export function addTodo(data) {
  return request(MANAGEMENT + `/flow/addTodo`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

//获取审批详情
export function getProcessById(data) {
  return request(MANAGEMENT + '/flow/getById', {
    method: 'GET',
    params: {
      ...data,
    },
  })
}

// 同意或拒绝审批
export function processingData(data) {
  return request(MANAGEMENT + `/flow/processingData`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 取消审批
export function cancelProcess(data) {
  return request(MANAGEMENT + `/flow/cancelProcess`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 审批完成的修改会议室
export function editorById(data) {
  return request(MANAGEMENT + `/flow/editorById`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 撤回审批
export function revokeProcess(data) {
  return request(MANAGEMENT + `/flow/revokeProcess`, {
    method: 'POST',
    data: {
      ...data,
    },
  })
}

// 分配人员/重新分配人员
export function assignPersonnel(data) {
  return request(MANAGEMENT + `/flow/assignPersonnel`, {
    method: 'POST',
    params: data,
  })
}

// 会务服务人完成服务接口
export function serviceComplete(data) {
  return request(MANAGEMENT + `/flow/serviceComplete`, {
    method: 'POST',
    params: data,
  })
}

// 会务评分
export function submitterGrade(data) {
  return request(MANAGEMENT + `/flow/submitterGrade`, {
    method: 'POST',
    params: data,
  })
}

// H5免密鉴权
export function authentication(data) {
  return request(MANAGEMENT + `/feishu/login/5/authentication`, {
    method: 'POST',
    params: data,
  })
}